import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CardInstruction from '../../../../components/CardInstruction';

import { getSosBudServiceId } from '../../../form/PensosbudForm/functions';

const SchoolMove = ({ i18n, sosBudServiceList }) => {
  const lang = (type, params) => i18n(`pensosbud.tab1.${type}`, { ...params });
  const serviceId = getSosBudServiceId(sosBudServiceList, 'transferSchool');

  const stepOuterList = [
    {
      label: i18n('pensosbud.step.take_number.title'),
      cta: i18n('pensosbud.step.take_number.cta'),
      link: `/pensosbud/registration/create?type=transferSchool&serviceId=${serviceId}`
    },
    {
      label: i18n('pensosbud.step.download.title'),
      cta: i18n('pensosbud.step.download.cta', { type: i18n('pensosbud.tab1.title') }),
      linkType: true,
      iconCta: 'download',
      ctaColor: 'outline',
      link: 'https://drive.google.com/file/d/1R60tiXpqrAuTFtdietQ1cZz6V8raTjIi/view'
    }
  ];

  const instructionList = [
    i18n('pensosbud.instruction_step.surat_keterangan_pindah'),
    i18n('pensosbud.instruction_step.raport'),
    i18n('pensosbud.instruction_step.ijasah'),
    i18n('pensosbud.instruction_step.passport_ortu'),
    i18n('pensosbud.instruction_step.akte_lahir'),
    i18n('pensosbud.instruction_step.pernyataan_ortu'),
    i18n('pensosbud.instruction_step.selesai_tugas'),
    i18n('pensosbud.instruction_step.kjri_form'),
    i18n('pensosbud.instruction_step.send_all_doc'),
    i18n('pensosbud.instruction_step.min_3_days')
  ];

  return (
    <CardInstruction
      stepOuterList={stepOuterList}
      instructionList={instructionList}
      lang={lang}
    />
  );
};

SchoolMove.propTypes = {
  i18n: PropTypes.func,
  sosBudServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(SchoolMove);
